import { BaseService } from "@/script/core/service/BaseService"
import { QueryParam } from "@/script/core/service/DataService"

export class ReconService extends BaseService {
    public loadReconDetailList(queryParam: QueryParam): Promise<any> {
        return this.post("/api/rec/recon/detail-list/query", queryParam);
    }
}
